import { render, staticRenderFns } from "./CCNavItem.vue?vue&type=template&id=01034656&scoped=true&"
import script from "./CCNavItem.vue?vue&type=script&lang=ts&"
export * from "./CCNavItem.vue?vue&type=script&lang=ts&"
import style0 from "./CCNavItem.vue?vue&type=style&index=0&id=01034656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01034656",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
